import { render, staticRenderFns } from "./extra-druck-vorlagen.vue?vue&type=template&id=7b9283e4&lang=pug&"
import script from "./extra-druck-vorlagen.vue?vue&type=script&lang=js&"
export * from "./extra-druck-vorlagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports